import $ from 'jquery';
import Cropper from 'cropperjs';


function ImageEditorAdaptor() {

    this.image = $('#cropper')[0];
    this.cropper = null;
    this.params = null;

    let self = this;

    $('#image-edit-modal').on('shown.bs.modal', function () {
        self.cropper = new Cropper(self.image, {
            viewMode: 2,
            responsive: true,
            scalable: false,
            zoomable: false,
        })
    });

    $('#image-edit-modal').on('hide.bs.modal', function () {
        let cropData = self.cropper.getData();
        let canvasData = self.cropper.getCanvasData();
        let ratio = cropData.height/cropData.width;

        /* Center point of crop area in percent. */
        const percentX = (cropData.x + cropData.width / 2) / canvasData.naturalWidth
        const percentY = (cropData.y + cropData.height / 2) / canvasData.naturalHeight

        /* Calculate available space round image center position. */
        const cx = percentX > 0.5 ? 1 - percentX : percentX
        const cy = percentY > 0.5 ? 1 - percentY : percentY

        /* Calculate image rectangle respecting space round image from crop area. */
        let width = canvasData.naturalWidth
        let height = width * ratio
        if (height > canvasData.naturalHeight) {
            height = canvasData.naturalHeight
            width = height / ratio
        }

        const rectWidth = cx * 2 * width
        const rectHeight = cy * 2 * height

        /* Calculate zoom. */
        const zoom = Math.max(rectWidth / cropData.width, rectHeight / cropData.height)

        let res = {
                data: {
                    crop: {
                        center: {
                            x: percentX,
                            y: percentY
                        },
                        flip: {
                            horizontal: false,
                            vertical: false
                        },

                        // How far to zoom the image
                        zoom: zoom,

                        // Rotation of image
                        rotation: 0,

                        // Aspect ratio of crop, `null` === free
                        aspectRatio: ratio
                    }
                }
        }

        console.log(res);

        self.onconfirm(res);

        // self.onclose();
        self.cropper.destroy();
        URL.revokeObjectURL(self.image.src);

    });
}

ImageEditorAdaptor.prototype.open = function (file, instruction) {
    this.params = instruction.crop;
    this.image.src = URL.createObjectURL(file);
    $('#image-edit-modal').modal();

};

// ImageEditorAdaptor.prototype.onconfirm = function (output) {
//
// };

// ImageEditorAdaptor.prototype.oncancel = function ()  {
//
// };

// ImageEditorAdaptor.prototype.onclose = function () {
//
// };

export default ImageEditorAdaptor;
